import React from "react";
// Page Components
import ServicesSection from "../components/ServicesSection";
// Animations
import { motion } from 'framer-motion';
import { pageAnimation } from "../animation";

const Services = () => {
    return(
        <motion.div
            variants={pageAnimation} 
            initial="hidden" 
            exit="exit" 
            animate="show"
        >
            <ServicesSection />
        </motion.div>
    );
};

export default Services;